import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES } from 'shared/constants';

const propsSchema = [
  {
    key: 'section_title',
    label: 'Section Title',
    type: types.TEXT
  },
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'items',
    label: 'Gallery Items',
    type: types.ARRAY,
    children: [
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'count',
        label: 'Number of Images',
        type: types.TEXT
      },
      {
        key: 'link',
        label: 'Page Link',
        type: types.TEXT
      },
      {
        key: 'url',
        label: 'Image Url',
        type: types.TEXT
      },
    ]
  }
];

const defaultProps = {
  section_title: 'Latest media',
  color_theme: 'DARK',
  items: [
    {
      title: 'Monaco ePrix',
      count: '5',
      link: '/gallery/formula-e-1',
      url: 'https://genesis-cdn.ff.com/homepage/02_slats/01_ff91.jpg'
    },
    {
      title: 'Buenos Aires ePrix',
      count: '6',
      link: '/gallery/formula-e-1',
      url: 'https://genesis-cdn.ff.com/homepage/02_slats/02_ffzero1.jpg'
    },
    {
      title: 'Mexico ePrix',
      count: '8',
      link: '/gallery/formula-e-1',
      url: 'https://genesis-cdn.ff.com/homepage/02_slats/03_ourcompany.jpg'
    },
    {
      title: 'Montreal ePrix',
      count: '4',
      link: '/gallery/formula-e-1',
      url: 'https://genesis-cdn.ff.com/homepage/02_slats/04_futuresight.jpg'
    }
  ]
};

export default {
  title: 'Scroll Gallery',
  id: 'ScrollGallery',
  propsSchema,
  defaultProps
};
